import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { WorkorderAfterSales1ModalComponent } from '../workorder-after-sales1-modal/workorder-after-sales1-modal.component';
import { WorkorderAfterSales4ModalComponent } from '../workorder-after-sales4-modal/workorder-after-sales4-modal.component';

@Component({
  selector: 'app-bus-seat-workorder-panel',
  templateUrl: './bus-seat-workorder-panel.component.html',
  styleUrls: ['./bus-seat-workorder-panel.component.scss'],
})
export class BusSeatWorkorderPanelComponent implements OnInit {
  @Input() data: any;
  formGroup: UntypedFormGroup;
  localStoreBusSeatID = 0;

  constructor(
    private api: UserApiService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private message: MessageService
  ) {
    this.formGroup = this.fb.group({
      detail: ['', [Validators.required]],
      icon: ['', []],
    });

    this.localStoreBusSeatID = Number(localStorage.getItem('bus_seat_id'));
  }

  ngOnInit(): void {
    this.findRemarks();
  }

  openAferSalesModal() {
    this.dialog.open(WorkorderAfterSales1ModalComponent, {
      data: Object.assign({}, this.data, {
        platform_name: this.data.bus.platform.name,
      }),
    });
  }

  loading = false;
  flagSolve = true;
  async solve(i: number) {
    try {
      this.loading = true;
      const r = await this.api.solveWorkProblem(this.data.id, i);
      if (r.status === 0) {
        if (i === 1) {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/user/profile/seats']);
            });

          //针对帮助中心
          localStorage.removeItem('bus_seat_id');
        } else {
          this.flagSolve = false;
          this.getWorkProblem();
        }
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async reply() {
    if (!this.formGroup.value.detail) {
      this.message.warn('请填写内容', { position: 'top' });
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.createWorkPrblemdetail(
        this.data.bus.id,
        this.data.id,
        this.data.bus.platform_id,
        this.data.bus.bus_account_id,
        '',
        this.work_problem_re,
        this.formGroup.value.icon,
        this.formGroup.value.detail
      );
      if (r.status === 0) {
        this.dialog.open(WorkorderAfterSales4ModalComponent, {
          data: Object.assign(
            {},
            { platform_name: this.data.bus.platform.name }
          ),
        });
      } else if (r.status === 1) {
        this.message.warn('工单重复提交');
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  work_problem_re = 0;
  async getWorkProblem() {
    try {
      const r = await this.api.getWorkProbem(this.data.id);
      this.work_problem_re = r.data.work_problem_re;
    } catch (error) {}
  }

  list: any = [];
  async findRemarks() {
    try {
      const r = await this.api.findWorkorderRemarks(
        this.data.bus.platform.name,
        'zh-CN'
      );
      this.list = r.data[0].text;
    } catch (error) {}
  }
}
